import { render, staticRenderFns } from "./LyricistEdit.vue?vue&type=template&id=85700bb6&"
import script from "./LyricistEdit.vue?vue&type=script&lang=js&"
export * from "./LyricistEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85700bb6')) {
      api.createRecord('85700bb6', component.options)
    } else {
      api.reload('85700bb6', component.options)
    }
    module.hot.accept("./LyricistEdit.vue?vue&type=template&id=85700bb6&", function () {
      api.rerender('85700bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LyricistEdit.vue"
export default component.exports